import React from 'react';
import { Footer } from './components/Footer';
import { Box, Flex, Stack, VStack } from '@chakra-ui/react';
import { Header } from './components/Header';
import { ProgressBar } from './components/ProgressBar';
import { Routes } from './components/Routes';

function App() {
    const contentWidth = 1100;

    return (
        <Flex direction="column" height="100vh">
            <VStack boxShadow="md" height={16} rounded="md" bg="white">
                <Box maxW={contentWidth} height={16} w="100%" alignContent="center">
                    <Header />
                </Box>
            </VStack>
            <VStack mt={6}>
                <ProgressBar paddingTop={4} paddingBottom={4} boxSize={contentWidth} />
            </VStack>
            <Box h="full" w="full" mt={10} overflow="scroll">
                <Stack spaceYReverse>
                    <VStack>
                        <Box paddingTop={4} paddingBottom={4} maxW={contentWidth} w="100%">
                            <Routes />
                        </Box>
                    </VStack>
                </Stack>
            </Box>
            <VStack bg="brand.100">
                <Footer paddingTop={6} paddingBottom={6} boxSize={contentWidth} />
            </VStack>
        </Flex>
    );
}

export default App;
